export const publicaColors = {
  // colors labeled as is
  black: '#000000',
  white: '#FFFFFF',
  blue: '#4952FF',
  teal: '#4FC1B5',
  green: '#3FD077',
  darkGreen: '#00B42A',
  veryLightGreen: '#E8FFEA',
  yellow: '#FEE72F',
  red: '#FA0E0E',
  veryLightRed: '#FFECE8',
  purple: '#B55DF5',
  ivory: '#FEFFF4',
  iceWhite: '#f0f4fc',
  whiteOrchid: '#f8fafe',
  lightBlue: '#5D66FA',
  lighterBlue: '#EDEEFF',
  veryLightBlue: '#F8FAFF',
  darkBlue: '#0009B4',
  lightTeal: '#51c3b5',
  lighterYellow: '#fcfcde',
  turquoise: '#00B7A9',
  honeydew: '#D9F6ED',
  jungleGreen: '#00C488',
  navy: '#273653',
  tan: '#C6AC8F',
  lavender: '#E0E3FF',
  mahogany: '#A75E6E',
  orange: '#F3A916',
  // sticker colors
  lightGreen: '#3cd079',
  mint: '#e8fcf4',
  lightYellow: '#ffeb2f',
  veryLightYellow: '#fffce4',
  lightRed: '#ff0d0d',
  lightPurple: '#b55ef8',
  // gray scale
  veryDarkGray: '#292F36',
  darkGray: '#434343',
  gray: '#707070',
  mediumGray: '#BDBDBD',
  mediumLightGray: '#929599',
  lightGray: '#E0E0E0',
  lighterGray: '#F2F2F2',
  veryLightGray: '#f6f6f6',
  veryLightPurple: '#D9B8FF',
};

export const graphColors = {
  blue: '#4952FF',
  teal: '#4FC1B5',
  green: '#3FD077',
  yellow: '#FEE72F',
  red: '#FA0E0E',
  purple: '#B55DF5',
  lightBlue: '#454eff',
  lightTeal: '#51c3b5',
  lightGreen: '#3cd079',
  lightYellow: '#ffeb2f',
  lightRed: '#ff0d0d',
  lightPurple: '#b55ef8',
  lightPink: '#FFB6C1',
  lightOrange: '#FF9900',
  darkGreen: '#00B42A',
  darkNavy: '#00324a',
  lightblue: '#5D66FA',
  redOrange: '#FF4E29',
  mustard: '#F3C628',
  lavendarPurple: '#6F60DD',
  turquoise: '#00B7A9',
  coralPink: '#FB6376',
  fluorescentPink: '#FF66FF',
  magentaDye: '#D30C7B',
  deepLilac: '#A34FC2',
  lightLavendar: '#8377D1',
  cyan: '#ACF8F4',
};

export const IntegralPlatformColors = {
  midnight: '#00324a',
  goldenrod: '#e6b710',
  orchid: '#acb7ff',
  turquoise: '#00b7a9',
  lightGray: '#8099a5',
  red: '#f03827',
  indigo: '#4e62e0',
  darkGray: '#335b6e',
  yellow: '#ffd12b',
};

export const muiColors = {
  checkbox: '#354975',
};
